import script from "./QuizzIllustrationCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuizzIllustrationCard.vue?vue&type=script&setup=true&lang=ts"

import "./QuizzIllustrationCard.vue?vue&type=style&index=0&id=4c301f3a&scoped=true&lang=scss"

import exportComponent from "D:\\wamp\\www\\GSALT\\gsalt-matters-ibd-denmark\\web\\modules\\vuejs\\vuejs-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c301f3a"]])

export default __exports__